import { CHNANGE_LISTVIEW_TAB } from "../actionTypes";

const changeListViewTabReducer = (state = 4, action) => {
  switch (action.type) {
    case CHNANGE_LISTVIEW_TAB:
      return action.payload;
    default:
      return state;
  }
};

export default changeListViewTabReducer;
